import { RouteProps } from 'react-router-dom'
import { LoginPage } from '../../../pages/LoginPage'
import { UsersPage } from '../../../pages/UsersPage'
import { ProfilePage } from '../../../pages/ProfilePage'
import { ClientsPage } from '../../../pages/ClientsPage'
import { LicensePage } from '../../../pages/LicensePage'
import { LicensesPage } from '../../../pages/LicensesPage'
import { ProductsPage } from '../../../pages/ProductsPage'
import { NotFoundPage } from '../../../pages/NotFoundPage/ui/NotFoundPage'
import { AppsPage } from '../../../pages/AppsPage'
import { ProductPage } from '../../../pages/ProductPage'
import { ClientPage } from '../../../pages/ClientPage'
import { AppPage } from '../../../pages/AppPage'
import { AppSecretKeyPage } from '../../../pages/AppSecretKeyPage'
import { AdminPage } from '../../../pages/AdminPage'
import { LoginForm } from '../../../pages/LoginPage/ui/LoginForm'
import { MfaForm } from '../../../pages/LoginPage/ui/MfaForm'
import { AuthCallback } from '../../../entities/AuthUser/ui/AuthCallback'

export type AppRoutesProps = RouteProps & {
	private?: boolean
}

export enum AppRoutes {
	NOT_FOUND = 'not_found',
	LOGIN = 'login',
	LOGIN_MFA = 'login_mfa',
	AUTH_GOOGLE = 'auth_google',
	USERS = 'users',
	USERS_USERID = 'users_userId',
	PROFILE = 'profile',
	CLIENTS = 'clients',
	CLIENTS_CLIENTID = 'clients_clientId',
	LICENSES = 'licenses',
	LICENSES_LICENSEID = 'licenses_licenseId',
	PRODUCTS = 'products',
	PRODUCTS_PRODUCTID = 'products_productId',
	APPLICATIONS = 'applications',
	APPLICATIONS_APPID = 'applications_appId',
	APPLICATIONS_APPID_SECRET = 'applications_appId_secret',
	ADMIN_ACTIONS = 'admin_actions',
}

export const RoutePath: Record<AppRoutes, string> = {
	[AppRoutes.NOT_FOUND]: '*',
	[AppRoutes.LOGIN]: '/login',
	[AppRoutes.LOGIN_MFA]: '/mfa',
	[AppRoutes.AUTH_GOOGLE]: '/auth/google',
	[AppRoutes.USERS]: '/users',
	[AppRoutes.USERS_USERID]: '/users/:userId',
	[AppRoutes.PROFILE]: '/profile',
	[AppRoutes.CLIENTS]: '/clients',
	[AppRoutes.CLIENTS_CLIENTID]: '/clients/:clientId',
	[AppRoutes.LICENSES]: '/licenses',
	[AppRoutes.LICENSES_LICENSEID]: '/licenses/:licenseId',
	[AppRoutes.PRODUCTS]: '/products',
	[AppRoutes.PRODUCTS_PRODUCTID]: '/products/:productId',
	[AppRoutes.APPLICATIONS]: '/applications',
	[AppRoutes.APPLICATIONS_APPID]: '/applications/:appId',
	[AppRoutes.APPLICATIONS_APPID_SECRET]: '/applications/:appId/secret',
	[AppRoutes.ADMIN_ACTIONS]: '/adminActions'
}

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
	[AppRoutes.NOT_FOUND]: {
		path: RoutePath.not_found,
		element: <NotFoundPage />
	},
	[AppRoutes.LOGIN]: {
		path: RoutePath.login,
		element: (
			<LoginPage>
				<LoginForm />
			</LoginPage>
		)
	},
	[AppRoutes.LOGIN_MFA]: {
		path: RoutePath.login_mfa,
		element: (
			<LoginPage>
				<MfaForm />
			</LoginPage>
		)
	},
	[AppRoutes.AUTH_GOOGLE]: {
		path: RoutePath.auth_google,
		element: <AuthCallback />
	},
	[AppRoutes.PROFILE]: {
		path: RoutePath.profile,
		element: <ProfilePage />,
		private: true
	},
	[AppRoutes.LICENSES]: {
		path: RoutePath.licenses,
		element: <LicensesPage />,
		private: true
	},
	[AppRoutes.LICENSES_LICENSEID]: {
		path: RoutePath.licenses_licenseId,
		element: <LicensePage />,
		private: true
	},
	[AppRoutes.CLIENTS]: {
		path: RoutePath.clients,
		element: <ClientsPage />,
		private: true
	},
	[AppRoutes.CLIENTS_CLIENTID]: {
		path: RoutePath.clients_clientId,
		element: <ClientPage />,
		private: true
	},
	[AppRoutes.PRODUCTS]: {
		path: RoutePath.products,
		element: <ProductsPage />,
		private: true
	},
	[AppRoutes.PRODUCTS_PRODUCTID]: {
		path: RoutePath.products_productId,
		element: <ProductPage />,
		private: true
	},
	[AppRoutes.USERS]: {
		path: RoutePath.users,
		element: <UsersPage />,
		private: true
	},
	[AppRoutes.USERS_USERID]: {
		path: RoutePath.users_userId,
		element: <ProfilePage />,
		private: true
	},
	[AppRoutes.APPLICATIONS]: {
		path: RoutePath.applications,
		element: <AppsPage />,
		private: true
	},
	[AppRoutes.APPLICATIONS_APPID]: {
		path: RoutePath.applications_appId,
		element: <AppPage />,
		private: true
	},
	[AppRoutes.APPLICATIONS_APPID_SECRET]: {
		path: RoutePath.applications_appId_secret,
		element: <AppSecretKeyPage />,
		private: true
	},
	[AppRoutes.ADMIN_ACTIONS]: {
		path: RoutePath.admin_actions,
		element: <AdminPage />,
		private: true
	}
}
